import { mapCommandCenterEarnings } from 'app/pages/tpoPortal/commandCenterHome/CommandCenterHome/earnings.utils';
import { tpoRecapEarningsApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

import { CommandCenterLoadKey, markCommandCenterLoadedAction } from './loadStatus.actions';

// EARNED pillar is owner-only, legal-gated AND broker-channel-only. Depending on the
// tenant the read returns 403 (the tpoRecap.viewEarnings owner claim not yet seeded)
// OR 404 (no earnings surface for this broker). The forbidden-skip keeps a 403 from
// tripping the shared page-reload interceptor; fetchSafe swallows the rejection itself
// so it degrades to the empty hero state with no "Unknown error" toast (DEV-4370).
const SKIP_FORBIDDEN_CONFIG = { skipResponseInterceptor: { forbiddenError: true } };

export const COMMAND_CENTER_EARNINGS_ACTION_TYPE = createNamedActions('commandCenterEarnings', {
  SET_EARNINGS: 'SET_EARNINGS',
});

const fetchSafe = async request => {
  try {
    const { data } = await request();

    return data ?? null;
  } catch {
    return null;
  }
};

export const getCommandCenterEarningsAction = catchAsyncActionError(() => async dispatch => {
  try {
    const data = await fetchSafe(() =>
      tpoRecapEarningsApi.getEarnings({ config: SKIP_FORBIDDEN_CONFIG }),
    );

    dispatch({
      type: COMMAND_CENTER_EARNINGS_ACTION_TYPE.SET_EARNINGS,
      payload: mapCommandCenterEarnings(data),
    });
  } finally {
    // In a `finally` so the slice is marked loaded even when the read degrades to null —
    // otherwise the hero skeleton never clears.
    dispatch(markCommandCenterLoadedAction(CommandCenterLoadKey.EARNINGS));
  }
});
